module.exports = __webpack_public_path__ + "imgesssyaa/svg/Shield-protected.e3765e42.svg";